import type { RouteObject } from 'react-router-dom';

import { ADMIN_ROLES } from '@/auth/roles';
import { RequireRole } from '@/auth/RequireRole';

/**
 * Clients area. OWNED BY `m3-clients` (M3a); see docs/BUILD-ORCHESTRATION.md.
 *
 *   /clients              the list (trainers: their own members, no fees)
 *   /clients/new          onboarding: owner/admin only (decision 4)
 *   /clients/:clientId    the profile; tabs come from profileSections.tsx
 */
export const clientsRoutes: RouteObject[] = [
  {
    path: 'clients',
    handle: { crumb: 'Clients' },
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./ClientsPage')).ClientsPage }) },
      {
        path: 'new',
        handle: { crumb: 'Add member' },
        element: <RequireRole roles={ADMIN_ROLES} />,
        children: [{ index: true, lazy: async () => ({ Component: (await import('./NewClientPage')).NewClientPage }) }],
      },
      {
        path: ':clientId',
        handle: { crumb: 'Member' },
        lazy: async () => ({ Component: (await import('./ClientProfilePage')).ClientProfilePage }),
      },
    ],
  },
];
